import { ResultRadar } from "@/components/candidati/sim/result/ResultRadar";
import { ResultProfile } from "@/components/candidati/sim/result/ResultProfile";
import { ResultColumns } from "@/components/candidati/sim/result/ResultColumns";
import { ResultPitch } from "@/components/candidati/sim/result/ResultPitch";

export const SimResult = ({ result, onRestart }) => (
  <div className="sim-step" data-testid="sim-result">
    <div className="grid gap-8 lg:grid-cols-[minmax(0,1.1fr)_minmax(0,1fr)] lg:items-center">
      <ResultRadar scores={result.scores} />
      <ResultProfile result={result} />
    </div>
    <ResultColumns archetype={result.archetype} />
    <ResultPitch onRestart={onRestart} />
  </div>
);
